import XHR from '@/request/http'
const $h = new XHR()

// API URL 配置
const url = {
    // 知识点 API (KgKnowledgeController)
    page: '/admin/v1/kg/knowledge/page',
    save: '/admin/v1/kg/knowledge/save',
    del: '/admin/v1/kg/knowledge/delete',
    get: '/admin/v1/kg/knowledge/detail',
    list: '/admin/v1/kg/knowledge/list',
    tree: '/admin/v1/kg/knowledge/tree',
    
    // 关系 API (KgKnowledgeRelationController)
    relationList: '/admin/v1/kg/relation/list',
    relationSave: '/admin/v1/kg/relation/save',
    relationDel: '/admin/v1/kg/relation/delete',
    relationGet: '/admin/v1/kg/relation/detail',
    
    // 图谱 API
    getGraph: '/admin/v1/kg/relation/graph',
    
    // 超边 API (KgHyperedgeController)
    hyperedgeList: '/admin/v1/kg/hyperedge/list',
    hyperedgeSave: '/admin/v1/kg/hyperedge/save',
    hyperedgeDel: '/admin/v1/kg/hyperedge/delete',
    hyperedgeGet: '/admin/v1/kg/hyperedge/detail',
    hyperedgeBindKnowledge: '/admin/v1/kg/hyperedge/bindKnowledge',
    hyperedgeUnbindKnowledge: '/admin/v1/kg/hyperedge/unbindKnowledge',
    hyperedgeKnowledgeIds: '/admin/v1/kg/hyperedge/knowledgeIds',
    
    // 学习路径 API (KgStudyPathController)
    studyPathPage: '/admin/v1/kg/studypath/page',
    studyPathSave: '/admin/v1/kg/studypath/save',
    studyPathDel: '/admin/v1/kg/studypath/delete',
    studyPathGet: '/admin/v1/kg/studypath/detail',
    studyPathSaveKnowledges: '/admin/v1/kg/studypath/saveKnowledges',
    studyPathList: '/admin/v1/kg/studypath/list',
    studyPathKnowledgeList: '/admin/v1/kg/studypath/knowledgeList',
    studyPathKnowledgeSave: '/admin/v1/kg/studypath/knowledgeSave',
    studyPathKnowledgeDel: '/admin/v1/kg/studypath/knowledgeDel',
    
    // 章节知识点树 API
    knowledgeWithChapter: '/admin/v1/kg/knowledge/listKnowledgeWithChapter',
    relationListByChapter: '/admin/v1/kg/relation/list-by-chapter',
    
    // 资源知识点 API
    keypointPage: '/admin/v1/keypoint/page',

    // AI API
    aiGenerateNodes: '/admin/v1/kg/ai/analysisChapterResource',
    aiGenerateEdges: '/admin/v1/kg/ai/analysisKnowledgePointForKR',
    aiClearGraph: '/admin/v1/kg/ai/deleteKnowledgePointAndRelation',
}

// ==================== 知识点 API ====================

/**
 * 分页查询知识点
 * @param {Object} data - 查询参数 { page, size, keyword, courseId, chapterId }
 */
export async function page(data) {
    return $h.request(url.page, data, 'GET')
}

/**
 * 获取知识点列表（不分页）
 * @param {Object} data - 查询参数 { courseId, chapterId }
 */
export async function list(data) {
    return $h.request(url.list, data, 'GET')
}

/**
 * 保存知识点（新增/更新）
 * @param {Object} data - 知识点数据
 */
export async function save(data) {
    return $h.request(url.save, data, 'POST')
}

/**
 * 删除知识点
 * @param {String|Number} id - 知识点ID
 */
export async function del(id) {
    return $h.request(url.del + '/' + id, {}, 'POST')
}

/**
 * 获取知识点详情
 * @param {String|Number} id - 知识点ID
 */
export async function get(id) {
    return $h.request(url.get + '/' + id, {}, 'GET')
}

/**
 * 获取章节知识点树形结构
 * @param {String|Number} courseId - 课程ID
 */
export async function tree(courseId) {
    return $h.request(url.tree, { courseId: courseId }, 'GET')
}

// ==================== 关系 API ====================

/**
 * 获取知识点关系列表
 * @param {Object} data - 查询参数 { courseId }
 */
export async function relationList(data) {
    return $h.request(url.relationList, data, 'GET')
}

/**
 * 保存关系（新增/更新）
 * @param {Object} data - 关系数据 { sourceId, targetId, relationType, description }
 */
export async function relationSave(data) {
    return $h.request(url.relationSave, data, 'POST')
}

/**
 * 删除关系
 * @param {String|Number} id - 关系ID
 */
export async function relationDel(id) {
    return $h.request(url.relationDel + '/' + id, {}, 'POST')
}

/**
 * 获取关系详情
 * @param {String|Number} id - 关系ID
 */
export async function relationGet(id) {
    return $h.request(url.relationGet + '/' + id, {}, 'GET')
}

// ==================== 图谱 API ====================

/**
 * 获取知识图谱数据
 * @param {Object} data - 查询参数 { courseId }
 */
export async function getGraph(data) {
    return $h.request(url.getGraph, data, 'GET')
}

// ==================== 超边 API ====================

/**
 * 获取超边列表
 * @param {Object} data - 查询参数 { courseId, hyperedgeType }
 */
export async function hyperedgeList(data) {
    return $h.request(url.hyperedgeList, data, 'GET')
}

/**
 * 保存超边（新增/更新）
 * @param {Object} data - 超边数据
 */
export async function hyperedgeSave(data) {
    return $h.request(url.hyperedgeSave, data, 'POST')
}

/**
 * 删除超边
 * @param {String|Number} id - 超边ID
 */
export async function hyperedgeDel(id) {
    return $h.request(url.hyperedgeDel + '/' + id, {}, 'POST')
}

/**
 * 获取超边详情
 * @param {String|Number} id - 超边ID
 */
export async function hyperedgeGet(id) {
    return $h.request(url.hyperedgeGet + '/' + id, {}, 'GET')
}

/**
 * 绑定知识点到超边
 * @param {String|Number} hyperedgeId - 超边ID
 * @param {Array} knowledgeIds - 知识点ID列表
 */
export async function hyperedgeBindKnowledge(hyperedgeId, knowledgeIds) {
    return $h.request(url.hyperedgeBindKnowledge + '?hyperedgeId=' + hyperedgeId, knowledgeIds, 'POST')
}

/**
 * 解绑超边中的知识点
 * @param {String|Number} hyperedgeId - 超边ID
 * @param {Array} knowledgeIds - 知识点ID列表
 */
export async function hyperedgeUnbindKnowledge(hyperedgeId, knowledgeIds) {
    return $h.request(url.hyperedgeUnbindKnowledge + '?hyperedgeId=' + hyperedgeId, knowledgeIds, 'POST')
}

/**
 * 获取超边绑定的知识点ID列表
 * @param {String|Number} id - 超边ID
 */
export async function hyperedgeKnowledgeIds(id) {
    return $h.request(url.hyperedgeKnowledgeIds + '/' + id, {}, 'GET')
}

// ==================== 学习路径 API ====================

/**
 * 分页查询学习路径
 * @param {Object} data - 查询参数 { courseId, name, status, page, size }
 */
export async function studyPathPage(data) {
    return $h.request(url.studyPathPage, data, 'GET')
}

/**
 * 保存学习路径（新增/更新）
 * @param {Object} data - 学习路径数据
 */
export async function studyPathSave(data) {
    return $h.request(url.studyPathSave, data, 'POST')
}

/**
 * 删除学习路径
 * @param {String|Number} id - 学习路径ID
 */
export async function studyPathDel(id) {
    return $h.request(url.studyPathDel + '/' + id, {}, 'POST')
}

/**
 * 获取学习路径详情（含知识点）
 * @param {String|Number} id - 学习路径ID
 */
export async function studyPathGet(id) {
    return $h.request(url.studyPathGet + '/' + id, {}, 'GET')
}

/**
 * 保存学习路径知识点（批量排序）
 * @param {String|Number} studyPathId - 学习路径ID
 * @param {Array} knowledgeIds - 知识点ID列表（按顺序）
 */
export async function studyPathSaveKnowledges(studyPathId, knowledgeIds) {
    return $h.request(url.studyPathSaveKnowledges + '?studyPathId=' + studyPathId, knowledgeIds, 'POST')
}

/**
 * 获取学习路径列表（不分页）
 * @param {Object} data - { courseId }
 */
export async function studyPathList(data) {
    return $h.request(url.studyPathList, data, 'GET')
}

/**
 * 获取学习路径下的知识点列表
 * @param {Object} data - { studyPathId }
 */
export async function studyPathKnowledgeList(data) {
    return $h.request(url.studyPathKnowledgeList, data, 'GET')
}

/**
 * 保存学习路径知识点
 * @param {Object} data - { studyPathId, knowledgeId, orderIndex }
 */
export async function studyPathKnowledgeSave(data) {
    return $h.request(url.studyPathKnowledgeSave, data, 'POST')
}

/**
 * 删除学习路径知识点
 * @param {String|Number} id
 */
export async function studyPathKnowledgeDel(id) {
    return $h.request(url.studyPathKnowledgeDel + '/' + id, {}, 'POST')
}

// ==================== 章节知识点树 API ====================

/**
 * 获取章节知识点树（供级联选择器用）
 * @param {Object} data - { courseId }
 */
export async function knowledgeWithChapter(data) {
    return $h.request(url.knowledgeWithChapter, data, 'GET')
}

/**
 * 按章节获取关系列表
 * @param {Object} data - { courseId, chapterId }
 */
export async function relationListByChapter(data) {
    return $h.request(url.relationListByChapter, data, 'GET')
}

// ==================== 资源知识点 API ====================

/**
 * 按知识点名称查询关联的资源知识点列表
 * @param {Object} data - { keyPoint, page, size }
 */
export async function knowledgeResourceList(data) {
    return $h.request(url.keypointPage, data, 'GET')
}

// ==================== AI API ====================

/**
 * AI生成知识点
 * @param {Object} data - { courseId }
 */
export async function aiGenerateNodes(data) {
    return $h.request(url.aiGenerateNodes, data, 'POST')
}

/**
 * AI生成关系
 * @param {Object} data - { courseId }
 */
export async function aiGenerateEdges(data) {
    return $h.request(url.aiGenerateEdges, data, 'POST')
}

/**
 * 清除图谱内容
 * @param {Object} data - { courseId }
 */
export async function aiClearGraph(data) {
    return $h.request(url.aiClearGraph, data, 'POST')
}
